import nativeHandlerService from "../nativeHandler";
import store from "@/store";
import API from "@/API";

export default {
  // 購入画面へ進む前に登録情報を確認
  async isValidUserInfo(isUsingBirthDate = true) {
    // 未ログイン時にプロファイル登録のダイアログが出ないよう、クレカチェックが先
    // remove check credit-card because sbps function
    return await this.checkProfile(isUsingBirthDate);
  },
  // プロファイルチェック
  async checkProfile(isUsingBirthDate = true) {
    try {
      const masterBook = store.getters["ticketing/masterBook"];
      if (
        isNeedProfile(masterBook)
      ) {
        return await this.isValidProfile(isUsingBirthDate);
      } else {
        return true;
      }
    } catch (err) {
      return false;
    }
  },
  // ユーザーがプロファイルの登録しているかをMJに確認する必要がある
  async isValidProfile(isUsingBirthDate = true) {
    try {
      // POST用にuser_idをidTokenから抽出する
      var user_id = await this.getUserIdFromIdToken();
      const userProfile = await store.dispatch("backend/getUserProfile", {
        id: user_id,
      });

      // check user profile 
      if (isUsingBirthDate && userProfile.data?.attribute?.gender && userProfile.data?.attribute?.birth_date) {
        return true;
      }
      else if (!isUsingBirthDate && userProfile.data?.attribute?.gender && userProfile.data?.attribute?.birth_year) {
        return true;
      }
      else {
        nativeHandlerService.returnNativeAppToProfile();
        return false;
      }
    } catch (err) {
      console.log("err.response.data.error :>> ", err.response.data.error);
      if (err.response.data.error == "not_found") {
        nativeHandlerService.returnNativeAppToProfile();
      } else {
        alert("別のエラー発生", err);
      }
      return false;
    }
  },
  // idTokenからbase64デコードしてuserIdに該当する部分を抜き出す
  getUserIdFromIdToken() {
    try {
      const parts = store.getters["common/idToken"].split(".");
      const base64Decoded = atob(parts[1]); // base64デコード。古いブラウザだとatob()が使えない場合がある
      const payload = JSON.parse(base64Decoded);
      return payload.sub;
    } catch (e) {
      console.log("error in getUserIdFromIdToken", e);
    }
  },
  // カード情報チェック(MFITTでネイティブダイアログを出さない場合もあるので、その場合はparamsにfalseを渡す)
  async checkCreditCard(isShowNativeAlert = true) {
    try {
      // カード情報を取得・storeへ格納
      await API.getCardInfo();
      const creditCard = store.getters["common/CreditCard"];
      if (creditCard.card_status == "exist") {
        return true;
      } else {
        if (isShowNativeAlert) {
          // クレカ登録がないもしくは有効でない場合
          switch (creditCard.card_status) {
            case "nothing":
              nativeHandlerService.returnNativeAppToCreditCardPageNothing();
              break;
            case "suspended":
              nativeHandlerService.returnNativeAppToCreditCardPageSuspended();
              break;
            case "unknown":
              nativeHandlerService.returnNativeAppToCreditCardPageUnknown();
              break;
            default:
              break;
          }
        }
        return false;
      }
    } catch (e) {
      console.log("error in checkCreditCard:", e);
      return false;
    }
  },
};


const isNeedProfile = (masterBook) => {
  const targetValues = [
    "register_profile_attribution", // 2022.7までの設定値. 移行期間を考慮し含めておく
    "app-register_profile",
    "any-register_profile"
  ];
  return targetValues.includes(masterBook.hold_condition);
}